<div [@onRenderUp] id="poll-form" class="page-layout simple fullwidth p-24">
    <!-- Header -->
    @if (periodSelected(); as period) {
        <div class="p-24">
            <h1 style="font-size: 300%" class="tituloAzul">{{ period.name }}</h1>
        </div>
    }
    @if (periodSelected()?.headerContent && projectId() != 94) {
        <div
            fxLayout="row"
            style="width: 80%; margin-left: 10%"
            fxLayoutAlign="space-between center"
            class="pt-24 pl-24 pr-24"
        >
            <div [innerHTML]="periodSelected()?.headerContent"></div>
        </div>
    }
    @if (periodSelected()?.headerImg && projectId() == 94) {
        <div fxLayout="row" fxLayoutAlign="center center" class="pt-24 pl-24 pr-24">
            <img style="width: 50%" [src]="periodSelected().headerImg" alt="Descripción de la imagen" />
        </div>
    }

    <div
        fxLayout="row"
        style="width: 80%; margin-left: 10%"
        fxLayoutAlign="space-between center"
        class="pt-24 pl-24 pr-24"
    >
        <h3 class="m-0 font-size-20 text-theme">{{ "poll.responde" | translate }}</h3>
    </div>

    <div fxLayout="row" style="width: 80%; margin-left: 10%" class="eval-form">
        <!-- EVALUATION -->
        @if (evaluationForm(); as form) {
            <div fxFlex="100" class="px-16 py-24">
                <!--||| General |||-->
                <div>
                    <div>
                        @for (section of selectedBlock()?.sections ?? []; track section.id || section) {
                            <div class="panel panel-card panel-theme">
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="space-between left"
                                    class="panel-heading"
                                    style="cursor: pointer"
                                    (click)="tooglePanel(section)"
                                >
                                    <h3 class="panel-title">
                                        <b style="font-size: 150%">{{ section.name }}</b>
                                    </h3>
                                    <mat-icon class="s-18" style="font-size: 150%">{{
                                        !section.extended ? "keyboard_arrow_down" : "keyboard_arrow_right"
                                    }}</mat-icon>
                                </div>
                                @if (!section.extended) {
                                    <div class="panel-body">
                                        <div>
                                            @if (
                                                periodSelected()?.headerContent &&
                                                projectId() == 94 &&
                                                section?.weight != 0
                                            ) {
                                                <div fxLayoutAlign="space-between center">
                                                    <div [innerHTML]="periodSelected()?.headerContent"></div>
                                                </div>
                                            }
                                            @for (element of section.elements; track element.id || element) {
                                                <div class="panel panel-theme" [class]="'panel-' + element.estado">
                                                    @if (element.type !== "TEXTAREA") {
                                                        <div
                                                            fxLayout="row"
                                                            fxLayoutAlign="start start"
                                                            class="panel-body"
                                                            style="width: 100%"
                                                        >
                                                            @if (evaluation()) {
                                                                <poll-input
                                                                    class="fullwidth"
                                                                    [element]="element"
                                                                    [userResult]="findElementResult(element.id)"
                                                                    [readOnly]="!editMode()"
                                                                    (onChangeValue)="onChangeElementValue($event)"
                                                                    (onChangeComment)="onChangeComment($event)"
                                                                >
                                                                </poll-input>
                                                            }
                                                        </div>
                                                    }
                                                    <div fxLayout="row" fxLayoutAlign="start start" class="p-8">
                                                        @if (element.name && element.type === "TEXTAREA") {
                                                            <h1 fxFlex="100" class="m-0 elementHead">
                                                                {{ element.name }}
                                                                @if (element.required == 1) {
                                                                    <b style="color: rgb(255, 50, 50)"> *</b>
                                                                }
                                                            </h1>
                                                        }
                                                    </div>
                                                    @if (element.type === "TEXTAREA") {
                                                        <div
                                                            fxLayout="row"
                                                            fxLayoutAlign="start start"
                                                            class="panel-body"
                                                            style="width: 100%"
                                                        >
                                                            @if (evaluation()) {
                                                                <poll-input
                                                                    class="fullwidth"
                                                                    [element]="element"
                                                                    [userResult]="findElementResult(element.id)"
                                                                    [readOnly]="!editMode()"
                                                                    (onChangeValue)="onChangeElementValue($event)"
                                                                    (onChangeComment)="onChangeComment($event)"
                                                                >
                                                                </poll-input>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
                @if (editMode()) {
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <h1></h1>
                        <button class="action-button" (click)="openDialog()">
                            <mat-icon class="mr-8">send</mat-icon>
                            {{ "poll.send" | translate }}
                        </button>
                    </div>
                }
            </div>
        }
    </div>
</div>
